import { LabeledValue, LabeledValue_Label, LabeledValue_Value } from 'emerald-ui';
import React from 'react';
import { DataHeaderRow } from '../DataHeaderRow';
import { DataSubHeaderRow } from '../DataSubHeaderRow';
import { DataHeader_Left, DataHeader_Right, DataHeader_Root } from './DataHeader.style';

/**
 * @typedef DataHeaderProps
 * @property {React.ReactNode} trackingNumber
 * @property {import('../DataHeaderRow').DataHeaderRowDataProp} [headerData]
 * @property {import('../DataSubHeaderRow').DataSubHeaderRowDataProp} [subHeaderData]
 */

/** @type {(props: DataHeaderProps & React.HTMLAttributes<HTMLDivElement>) => JSX.Element} */
export function DataHeader(props) {
    const {
        trackingNumber,
        headerData,
        subHeaderData,
        ...otherProps
    } = props;

    return (
        <DataHeader_Root {...otherProps}>
            <DataHeader_Left>
                <LabeledValue>
                    <LabeledValue_Label>
                        Tracking Number
                    </LabeledValue_Label>
                    <LabeledValue_Value>
                        {trackingNumber}
                    </LabeledValue_Value>
                </LabeledValue>
            </DataHeader_Left>
            {(headerData || subHeaderData) && (
                <DataHeader_Right>
                    {headerData && <DataHeaderRow data={headerData} />}
                    {subHeaderData && <DataSubHeaderRow data={subHeaderData} />}
                </DataHeader_Right>
            )}
        </DataHeader_Root>
    );
}
